<template>
    <app-layout>
      <Head title="Scheduled"/>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                Scheduled Messages
            </h2>
        </template>

        <div class="max-w-7xl mx-auto flex mb-6">
            <div class="w-full p-2 sm:px-6 lg:px-8">
                <div class="bg-white shadow-xl sm:rounded-lg p-4 sm:p-6 lg:p-8 overflow-hidden relative">
                    <scheduled-message-table></scheduled-message-table>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetDropdown from "./../../Jetstream/Dropdown";
import JetDropdownLink from "./../../Jetstream/DropdownLink";
import JetDialogModal from "./../../Jetstream/DialogModal";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";
import Button from "./../../Jetstream/Button";
import JetDangerButton from "./../../Jetstream/DangerButton";
import ScheduledMessageTable from "../../components/ScheduledMessageTable";
import axios from "axios";

export default {
    components: {
        AppLayout,
        JetDropdown,
        JetDropdownLink,
        JetDialogModal,
        Button,
        JetSecondaryButton,
        JetDangerButton,
        ScheduledMessageTable
    },
    props: {
        contacts: Array
    },
    data() {
        return {
            showDeletionModal: false,
            showEditModal: false,
            contactEditDetails: {
                first_name: null,
                last_name: null,
                phone_number: null,
                id: null
            },
            contactSetForDeletion: null
        };
    },
    computed: {
        contactDeleteRoute: function() {
            if (!this.contactSetForDeletion) {
                return "";
            }

            return route("contacts.delete", {
                id: this.contactSetForDeletion
            });
        }
    },
    methods: {
        deleteContact(id) {
            axios
                .get(route("contacts.delete", { id: id }))
                .then(function(res) {
                    console.log(res);
                })
                .catch(function(err) {
                    console.log(err);
                });
        },
        toggleDeletionModal(row) {
            if (!this.showDeletionModal) {
                this.contactSetForDeletion = row.id;
            }
            this.showDeletionModal = !this.showDeletionModal;
        },
        toggleEditModal(row) {
            if (!this.showEditModal) {
                this.contactEditDetails.first_name = row.first_name;
                this.contactEditDetails.last_name = row.last_name;
                this.contactEditDetails.phone_number = row.phone_number;
                this.contactEditDetails.id = row.id;
            }
            this.showEditModal = !this.showEditModal;
        }
    }
};
</script>
